import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Upload } from "lucide-react";
import gameimg5 from "../../assets/kangaroo/gamestep5.png";
import nepal from "../../assets/kangaroo/nepalflag.png";
import australia from "../../assets/kangaroo/newzealandflag.png";
import newZealandFlag from "../../assets/kangaroo/newzealandflag.png";
import ukFlag from "../../assets/kangaroo/newzealandflag.png";
import usaFlag from "../../assets/kangaroo/canadaflag.png";
import chinaFlag from "../../assets/kangaroo/newzealandflag.png";
import Dropdown from "../dropdown/Dropdown";
import Smallbutton from "../button/Smallbutton";
import FormClosepink from "../FormClosePink/FormClosepink";
import FormGoldBg from "../FormCloseGold/FormGoldBg";
import country from "../../common/data/country";
import { useMutation, useQuery } from "@tanstack/react-query";
import BranchService from "../../services/BranchService";
import Destinationcountry from "../../services/Destinationcountry";
import FormService from "../../services/FormService";
import FormClose from "../FormClose/FormClose";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";

const Fullform = (props) => {
  const isAppointment = props.isAppointment ?? false;
  const [countryCode, setCountryCode] = useState({
    id: 1,
    label: "+61",
    flag: australia,
  });
  const [selectedItem, setSelectedItem] = useState(null);
  const [preferedBranchId, setpreferedBranchId] = useState(null);
  const [selectedDestination, setSelectedDestination] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [thankYouModal, setThankYouModal] = useState(false);
  const toggleThankYou = () => setThankYouModal(!thankYouModal);
  const [selectedDate, setSelectedDate] = useState(null);
  const [availableData, setAvailableData] = useState([]);

  const fields = Object.keys(props).filter((key) => props[key] === true);
  const fetchAvailableSlot = async (date) => {
    if (!date) return;

    try {
      const response = await FormService.getAvailableSlot(
        date.toISOString().split("T")[0] // format as YYYY-MM-DD
      );
      setAvailableData(response);
    } catch (error) {
      console.log("Error fetching slots:", error);
      setAvailableData([]);
    }
  };

  useEffect(() => {
    fetchAvailableSlot(selectedDate);
  }, [selectedDate]);

  const createValidationSchema = () => {
    const schemaFields = {};

    if (props.fullName) {
      schemaFields.fullName = Yup.string()
        .min(2, "Name must be at least 2 characters")
        .max(100, "Name must not exceed 100 characters")
        .matches(/^[a-zA-Z\s]+$/, "Name can only contain letters and spaces")
        .required("Full name is required");
    }

    if (props.email) {
      schemaFields.email = Yup.string()
        .trim()
        .required("Email address is required")
        .matches(
          /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
          "Please enter a valid email address"
        )
        .max(254, "Email address is too long");
    }


    if (props.phone) {
      schemaFields.phone = Yup.string()
        .transform((value) => (value ? String(value) : "")) // ensure it's a string
        .matches(/^[0-9]+$/, "Phone number must contain only numbers") // no letters/special chars
        .min(10, "Phone number must be at least 10 digits") // minimum 10 digits
        .required("Phone number is required");
    }

    if (props.preferedBranchId) {
      schemaFields.preferedBranchId = Yup.string().required(
        "Please select nearest office"
      );
    }

    if (props.serviceId) {
      schemaFields.serviceId = Yup.string().required(
        "Please select study destination"
      );
    }

    if (props.intendedLevel) {
      schemaFields.intendedLevel = Yup.string().required(
        "Please select study level"
      );
    }

    if (props.callBackTime) {
      schemaFields.callBackTime = Yup.string().required(
        "Please select callback time"
      );
    }

    if (props.message) {
      schemaFields.message = Yup.string().max(
        1000,
        "Message must not exceed 1000 characters"
      );
    }

    if (props.priorExp) {
      schemaFields.priorExp = Yup.string().max(
        500,
        "Response must not exceed 500 characters"
      );
    }

    if (props.FrnExp) {
      schemaFields.FrnExp = Yup.string()
        .required("This field is required")
        .max(500, "Response must not exceed 500 characters");
    }

    if (props.InsOpening) {
      schemaFields.InsOpening = Yup.string()
        .required("Please explain your interest")
        .min(20, "Please provide at least 20 characters")
        .max(1000, "Response must not exceed 1000 characters");
    }

    if (props.uploadBtn) {
      schemaFields.uploadFile = Yup.mixed().required(
        "Please upload your EOI document"
      );
    }

    if (props.whereAbouts) {
      schemaFields.whereAbouts = Yup.string()
        .required("Please specify preferred locations")
        .min(10, "Please provide at least 10 characters")
        .max(500, "Response must not exceed 500 characters");
    }

    if (props.additionalInfo) {
      schemaFields.additionalInfo = Yup.string().max(
        2000,
        "Additional information must not exceed 2000 characters"
      );
    }

    if (props.localResident) {
      schemaFields.localResident = Yup.string()
        .required("Please select an option")
        .oneOf(["yes", "no"], "Please select a valid option");
    }

    if (props.plan) {
      schemaFields.plan = Yup.string()
        .required("Please select an option")
        .oneOf(["yes", "no"], "Please select a valid option");
    }

    if (props.investor) {
      schemaFields.investor = Yup.string()
        .required("Please select an option")
        .oneOf(["sole", "multiple"], "Please select a valid option");
    }

    if (props.address) {
      schemaFields.address = Yup.string()
        .required("Address is required")
        .min(10, "Address must be at least 10 characters")
        .max(200, "Address must not exceed 200 characters");
    }



    return Yup.object().shape(schemaFields);
  };

  const createInitialValues = () => {
    const values = {};

    if (props.fullName) values.fullName = "";
    if (props.email) values.email = "";
    if (props.phone) {
      values.phone = "";
      values.countryCode = "+61";
    }
    if (props.preferedBranchId) values.preferedBranchId = "";
    if (props.serviceId) values.serviceId = "";
    if (props.intendedLevel) values.intendedLevel = "";
    if (props.callBackTime) values.callBackTime = "";
    if (props.message) values.message = "";
    if (props.priorExp) values.priorExp = "";
    if (props.FrnExp) values.FrnExp = "";
    if (props.InsOpening) values.InsOpening = "";
    if (props.uploadBtn) values.uploadFile = null;
    if (props.whereAbouts) values.whereAbouts = "";
    if (props.additionalInfo) values.additionalInfo = "";
    if (props.localResident) values.localResident = "";
    if (props.plan) values.plan = "";
    if (props.investor) values.investor = "";
    if (props.address) values.address = "";
    if (props.appointment) {
      values.appointment = {
        date: null,
        startTime: null,
        endTime: null,
        selectAnyOne: true,
      };
    }
    if (props.formOrigin) values.formOrigin = props.formOrigin;

    return values;
  };

  const fetchDestinationData = async () => {
    const response = await Destinationcountry.getList();
    return response;
  };

  const {
    isPending,
    error,
    data: countryData,
  } = useQuery({
    queryKey: ["countryData"],
    queryFn: fetchDestinationData,
  });

  const countryOptions =
    countryData
      ?.filter((item) => item.isActive)
      ?.map((item) => ({
        id: item.id,
        label: item.name,
        slug: item.slug, // Add this line
      })) || [];

  const fetchOffice = async () => {
    const response = await BranchService.getList();
    return response?.items;
  };

  const { error: officeError, data: officeData } = useQuery({
    queryKey: ["officeData"],
    queryFn: fetchOffice,
    onSuccess: (data) => {
      console.log(data);
    },
  });

  const officeOptions =
    officeData?.map((item) => ({
      id: item.id,
      label: item.officeName,
    })) || [];

  const mutation = useMutation({
    mutationFn: async (values) => {
      if (props?.isFranchise === true) {
        const response = await FormService.createFranchise(values);
        return response;
      } else {
        const response = await FormService.create(values);
        return response;
      }
    },
    onError: (error) => {
      console.error("Error submitting form:", error);
    },
    onSuccess: () => {
      console.log("Form submitted successfully");
    },
  });

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    console.log("Form values:", values);

    // Ensure phone is a string
    const payload = {
      ...values,
      phone: String(values.phone),
      formOrigin: props.formOrigin,
    };

    if (props?.isBanner === true) {
      // Call parent banner submit handler
      props.onSubmit(values, props.selectedCountry, props.selectedCourse);
      // Reset form and dropdowns after banner submit
      setSubmitting(false);
      resetForm();
      setCountryCode({ id: 1, label: "+61", flag: australia });
      setSelectedItem(null);
      setSelectedDestination(null);
      setSelectedLevel(null);
      setSelectedTime(null);
      setpreferedBranchId(null);
      toggleThankYou();
    } else {
      // Submit via mutation
      mutation.mutate(payload, {
        onSuccess: () => {
          // Reset form & dropdowns on success
          resetForm();
          setCountryCode({ id: 1, label: "+61", flag: australia });
          setSelectedItem(null);
          setSelectedDestination(null);
          setSelectedLevel(null);
          setSelectedTime(null);
          setpreferedBranchId(null);
          toggleThankYou();
        },
        onSettled: () => {
          // Ensure submitting state is always reset
          setSubmitting(false);
        },
        onError: (error) => {
          console.error("Form submission error:", error);
        },
      });
    }
  };

  const renderField = (fieldName, formik) => {
    const { values, errors, touched, setFieldValue, setFieldTouched } = formik;

    switch (fieldName) {
      case "fullName":
        return (
          <Row key="fullName">
            <Col>
              <div>
                <label htmlFor="fullName" className="font-label">
                  Full Name*
                </label>
                <Field
                  type="text"
                  name="fullName"
                  className={`form-control form-box py-3 ${touched.fullName && errors.fullName ? "is-invalid" : ""
                    }`}
                  id="fullName"
                />
                <ErrorMessage
                  name="fullName"
                  component="div"
                  className="text-danger mt-1"
                  style={{ fontSize: "0.875rem" }}
                />
              </div>
            </Col>
          </Row>
        );
      case "appointment":
        return (
          <>
            {isAppointment && (
              <>
                <div className="d-flex flex-column col-lg-12">
                  {/* Appointment Date */}
                  <div className=" col-lg-12">
                    <label className="font-label">
                      Select a Date & Time that Suits you*
                    </label>
                    <Flatpickr
                      className="form-control p-3"
                      style={{ border: "1px solid #687C86" }}
                      options={{
                        dateFormat: "Y-m-d",
                        minDate: "today",
                      }}
                      value={values.appointment.date}
                      onChange={([date]) => {
                        setFieldValue("appointment.date", date);
                        setSelectedDate(date);
                      }}
                    />
                  </div>


                </div>

              </>
            )}
          </>
        );
      case "slots":
        return (

          <Row className="mt-0">
            {availableData?.map((slot, index) => (
              <Col key={index} md={3} className="mb-3" >
                <Card
                  onClick={() => {
                    formik.setFieldValue(
                      "appointment.startTime",
                      slot.startTime
                    );
                    formik.setFieldValue(
                      "appointment.endTime",
                      slot.endTime
                    ); // ⚡ set endTime too
                  }}
                  className={`cursor-pointer ${formik.values.appointment.startTime ===
                    slot.startTime
                    ? "border-primary"
                    : ""
                    }`}
                >
                  <CardBody>
                    {slot.startTime} - {slot.endTime}
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        )
      case "email":
        return (
          <Row key="email">
            <Col>
              <div>
                <label htmlFor="email" className="font-label">
                  Email Address*
                </label>
                <Field
                  type="email"
                  name="email"
                  className={`form-control form-box py-3 ${touched.email && errors.email ? "is-invalid" : ""
                    }`}
                  id="email"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-danger mt-1"
                  style={{ fontSize: "0.875rem" }}
                />
              </div>
            </Col>
          </Row>
        );

      case "phone":
        return (
          <Row key="phone">
            <Col>
              <div>
                <label htmlFor="phone" className="font-label">
                  Phone Number*
                </label>
                <div
                  className="d-flex justify-content-center align-items-start position-relative"
                  style={{
                    borderRadius: "8px",
                    transition: "box-shadow 0.2s ease-in-out",
                    border:
                      formik.errors.phone || formik.errors.countryCode
                        ? ""
                        : "none", // highlight border if error
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.boxShadow =
                      "0 0 0 4px rgba(13, 110, 253, 0.25)";
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <div style={{ flex: "0 0 6rem" }}>
                    <Dropdown
                      items={country.map((item) => ({
                        id: item.id,
                        label: item.countryCode,
                        flag: item.flagImg,
                      }))}
                      width="9rem"
                      selectedItem={countryCode}
                      setSelectedItem={(item) => {
                        setCountryCode(item);
                        formik.setFieldValue(
                          "countryCode",
                          item?.label || null
                        );
                      }}
                      phoneNumber={true}
                      placeholder="+61"
                      placeholderFlag={australia}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <Field
                      type="number"
                      name="phone"
                      value={formik.values.phone}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="form-control form-box py-3"
                      style={{
                        borderLeft: "0",
                        borderTop: "2px solid #687C86",
                        borderRight: "2px solid #687C86",
                        borderBottom: "2px solid #687C86",
                        borderTopRightRadius: "8px",
                        borderBottomRightRadius: "8px",
                        borderTopLeftRadius: "0",
                        borderBottomLeftRadius: "0",
                        boxSizing: "border-box",
                        paddingLeft: "12px",
                        width: "100%",
                        outline: "none",
                        boxShadow: "none",
                      }}
                    />
                  </div>
                </div>

                {/* Show error for the whole component */}
                {(formik.errors.phone || formik.errors.countryCode) && (
                  <div
                    className="text-danger mt-1"
                    style={{ fontSize: "0.875rem" }}
                  >
                    {formik.errors.countryCode
                      ? formik.errors.countryCode
                      : formik.errors.phone}
                  </div>
                )}
              </div>
            </Col>
          </Row>
        );

      case "preferedBranchId":
        return (
          <Row key="preferedBranchId">
            <Col>
              <div>
                <label htmlFor="preferedBranchId" className="font-label">
                  Nearest KEVS Office*
                </label>
                <Dropdown
                  items={officeOptions}
                  selectedItem={preferedBranchId}
                  setSelectedItem={(item) => {
                    setpreferedBranchId(item);
                    setFieldValue("preferedBranchId", item?.id || "");
                  }}
                  placeholder=" "
                />
                <ErrorMessage
                  name="preferedBranchId"
                  component="div"
                  className="text-danger mt-1"
                  style={{ fontSize: "0.875rem" }}
                />
              </div>
            </Col>
          </Row>
        );

      case "serviceId":
        return (
          <Row key="serviceId">
            <Col>
              <div>
                <label htmlFor="serviceId" className="font-label">
                  What Support Do you Need?*
                </label>
                <Dropdown
                  items={countryOptions}
                  selectedItem={selectedDestination}
                  setSelectedItem={(item) => {
                    setSelectedDestination(item);
                    setFieldValue("serviceId", item?.id || "");
                  }}
                  placeholder=" "
                />
                <ErrorMessage
                  name="serviceId"
                  component="div"
                  className="text-danger mt-1"
                  style={{ fontSize: "0.875rem" }}
                />
              </div>
            </Col>
          </Row>
        );

      case "intendedLevel":
        return (
          <Row key="intendedLevel">
            <Col>
              <div>
                <label htmlFor="intendedLevel" className="font-label">
                  Preferred Study Level*
                </label>
                <Dropdown
                  items={[
                    { id: 1, label: "Bachelor's" },
                    { id: 2, label: "Master's" },
                    { id: 3, label: "Masters by Research" },
                  ]}
                  selectedItem={selectedLevel}
                  setSelectedItem={(item) => {
                    setSelectedLevel(item);
                    setFieldValue("intendedLevel", item?.label || "");
                  }}
                  placeholder=" "
                />
                <ErrorMessage
                  name="intendedLevel"
                  component="div"
                  className="text-danger mt-1"
                  style={{ fontSize: "0.875rem" }}
                />
              </div>
            </Col>
          </Row>
        );

      case "location":
        return (
          <Row key="location">
            <Col>
              <div>
                <label htmlFor="intendedLevel" className="font-label">
                  Preferred Location to Open Office*
                </label>
                <Field
                  type="text"
                  name="intendedLevel"
                  className={`form-control form-box py-3 ${touched.intendedLevel && errors.intendedLevel
                    ? "is-invalid"
                    : ""
                    }`}
                  id="intendedLevel"
                />

                <ErrorMessage
                  name="intendedLevel"
                  component="div"
                  className="text-danger mt-1"
                  style={{ fontSize: "0.875rem" }}
                />
              </div>
            </Col>
          </Row>
        );
      case "prefreredLocation":
        return (
          <Row key="prefreredLocation">
            <Col>
              <div>
                <label htmlFor="prefreredLocation" className="font-label">
                  Preferred Location to Open Office*
                </label>
                <Field
                  type="text"
                  name="prefreredLocation"
                  className={`form-control form-box py-3 ${touched.prefreredLocation && errors.prefreredLocation
                    ? "is-invalid"
                    : ""
                    }`}
                  id="prefreredLocation"
                />
                <ErrorMessage
                  name="prefreredLocation"
                  component="div"
                  className="text-danger mt-1"
                  style={{ fontSize: "0.875rem" }}
                />
              </div>
            </Col>
          </Row>
        );
      case "callBackTime":
        return (
          <Row key="callBackTime">
            <Col>
              <div>
                <label htmlFor="callBackTime" className="font-label">
                  What time can we call you back*
                </label>
                <Dropdown
                  items={[
                    { id: 1, label: "10 AM - 11 AM" },
                    { id: 2, label: "11 AM - 12 PM" },
                    { id: 3, label: "12 PM - 1 PM" },
                    { id: 4, label: "1 PM - 2 PM" },
                    { id: 5, label: "2 PM - 3 PM" },
                    { id: 6, label: "3 PM - 4 PM" },
                    { id: 7, label: "4 PM - 5 PM" },
                  ]}
                  selectedItem={selectedTime}
                  setSelectedItem={(item) => {
                    setSelectedTime(item);
                    setFieldValue("callBackTime", item?.label || "");
                  }}
                  placeholder=" "
                />
                <ErrorMessage
                  name="callBackTime"
                  component="div"
                  className="text-danger mt-1"
                  style={{ fontSize: "0.875rem" }}
                />
              </div>
            </Col>
          </Row>
        );

      case "message":
        return (
          <Row key="message">
            <Col>
              <div>
                <label htmlFor="message" className="font-label">
                  Message (if any)
                </label>
                <Field
                  as="textarea"
                  name="message"
                  className={`form-control form-box ${touched.message && errors.message ? "is-invalid" : ""
                    }`}
                  id="message"
                  rows={8}
                  style={{ resize: "vertical" }}
                />
                <ErrorMessage
                  name="message"
                  component="div"
                  className="text-danger mt-1"
                  style={{ fontSize: "0.875rem" }}
                />
              </div>
            </Col>
          </Row>
        );

      case "priorExp":
        return (
          <Col sm={12} key="priorExp">
            <div>
              <label htmlFor="priorExp" className="font-label">
                Do you have any prior experience in Education Consultancy or
                Education Sector? <br />
                <span>
                  <small className="text-muted ">
                    (If yes, please provide details)
                  </small>
                </span>
              </label>
              <Field
                as="textarea"
                name="priorExp"
                className={`form-control form-height form-box ${touched.priorExp && errors.priorExp ? "is-invalid" : ""
                  }`}
                id="priorExp"
                style={{ resize: "vertical", height: "4rem" }}
              />
              <ErrorMessage
                name="priorExp"
                component="div"
                className="text-danger mt-1"
                style={{ fontSize: "0.875rem" }}
              />
            </div>
          </Col>
        );

      case "FrnExp":
        return (
          <Col sm={12} key="FrnExp">
            <div>
              <label htmlFor="FrnExp" className="font-label">
                Do you have any prior experience in Franchise Business?*
                <br />
                <span>
                  <small className="text-muted ">
                    (If yes, please provide details)
                  </small>
                </span>
              </label>
              <Field
                as="textarea"
                name="FrnExp"
                className={`form-control form-height form-box ${touched.FrnExp && errors.FrnExp ? "is-invalid" : ""
                  }`}
                id="FrnExp"
                style={{ resize: "vertical", height: "4rem" }}
              />
              <ErrorMessage
                name="FrnExp"
                component="div"
                className="text-danger mt-1"
                style={{ fontSize: "0.875rem" }}
              />
            </div>
          </Col>
        );

      case "InsOpening":
        return (
          <Col sm={12} key="InsOpening">
            <div>
              <label htmlFor="InsOpening" className="font-label">
                Why are you interested in opening Kangaroo Education
                Foundation's Regional Office?*
                <br />
              </label>
              <Field
                as="textarea"
                name="InsOpening"
                className={`form-control form-height form-box ${touched.InsOpening && errors.InsOpening ? "is-invalid" : ""
                  }`}
                id="InsOpening"
                style={{ resize: "vertical", height: "4rem" }}
              />
              <ErrorMessage
                name="InsOpening"
                component="div"
                className="text-danger mt-1"
                style={{ fontSize: "0.875rem" }}
              />
            </div>
          </Col>
        );

      case "uploadBtn":
        return (
          <Col sm={12} key="uploadBtn">
            <div>
              <label
                htmlFor="uploadFile"
                className="d-flex py-3 px-3 justify-content-center align-items-center gap-4 rounded-4"
                style={{
                  border: `1px solid ${touched.uploadFile && errors.uploadFile
                    ? "#dc3545"
                    : "#687c86"
                    }`,
                  width: "60%",
                  cursor: "pointer",
                }}
              >
                <Upload size={34} strokeWidth={3} color="#687c86" />
                <span className="font-label">
                  {values.uploadFile
                    ? values.uploadFile.name
                    : "Upload your Expression of Interest(EOI)"}
                </span>
              </label>
              <input
                id="uploadFile"
                name="uploadFile"
                type="file"
                style={{ display: "none" }}
                onChange={(event) => {
                  setFieldValue("uploadFile", event.currentTarget.files[0]);
                }}
                onBlur={() => setFieldTouched("uploadFile", true)}
              />
              <ErrorMessage
                name="uploadFile"
                component="div"
                className="text-danger mt-1"
                style={{ fontSize: "0.875rem" }}
              />
            </div>
          </Col>
        );

      case "whereAbouts":
        return (
          <Col sm={12} key="whereAbouts">
            <div>
              <label htmlFor="whereAbouts" className="font-label">
                Where are your Preferred Locations to open Kangaroo Education
                Foundation's Regional Office?*
                <br />
              </label>
              <Field
                as="textarea"
                name="whereAbouts"
                className={`form-control form-height form-box ${touched.whereAbouts && errors.whereAbouts ? "is-invalid" : ""
                  }`}
                id="whereAbouts"
                style={{ resize: "vertical", height: "4rem" }}
              />
              <ErrorMessage
                name="whereAbouts"
                component="div"
                className="text-danger mt-1"
                style={{ fontSize: "0.875rem" }}
              />
            </div>
          </Col>
        );

      case "additionalInfo":
        return (
          <Col sm={12} key="additionalInfo">
            <div>
              <label htmlFor="additionalInfo" className="font-label">
                Additional Information:
                <br />
                <small className="text-muted">
                  (Please feel free to provide any supplementary details or
                  comments here.)
                </small>
              </label>
              <Field
                as="textarea"
                name="additionalInfo"
                className={`form-control form-height form-box ${touched.additionalInfo && errors.additionalInfo
                  ? "is-invalid"
                  : ""
                  }`}
                id="additionalInfo"
                style={{ resize: "vertical", height: "15rem" }}
              />
              <ErrorMessage
                name="additionalInfo"
                component="div"
                className="text-danger mt-1"
                style={{ fontSize: "0.875rem" }}
              />
            </div>
          </Col>
        );

      case "localResident":
        return (
          <Col sm={12} key="localResident">
            <div>
              <label htmlFor="localResident" className="font-label">
                Are you a local resident where you want to open Kangaroo
                Education Foundation's?*
                <br />
              </label>
              <div className="d-flex align-items-center gap-4">
                <label className="d-flex align-items-center gap-2 font-label">
                  <Field
                    type="radio"
                    name="localResident"
                    value="yes"
                    style={{ transform: "scale(1.4)", cursor: "pointer" }}
                  />
                  Yes
                </label>
                <label className="d-flex align-items-center gap-2 font-label">
                  <Field
                    type="radio"
                    name="localResident"
                    value="no"
                    style={{ transform: "scale(1.4)", cursor: "pointer" }}
                  />
                  No
                </label>
              </div>
              <ErrorMessage
                name="localResident"
                component="div"
                className="text-danger mt-1"
                style={{ fontSize: "0.875rem" }}
              />
            </div>
          </Col>
        );

      case "plan":
        return (
          <Col sm={12} key="plan">
            <div>
              <label htmlFor="plan" className="font-label">
                Are you planning to operate this business as your full-time
                endeavor?*
                <br />
              </label>
              <div className="d-flex align-items-center gap-4">
                <label className="d-flex align-items-center gap-2 font-label">
                  <Field
                    type="radio"
                    name="plan"
                    value="yes"
                    style={{ transform: "scale(1.4)", cursor: "pointer" }}
                  />
                  Yes
                </label>
                <label className="d-flex align-items-center gap-2 font-label">
                  <Field
                    type="radio"
                    name="plan"
                    value="no"
                    style={{ transform: "scale(1.4)", cursor: "pointer" }}
                  />
                  No
                </label>
              </div>
              <ErrorMessage
                name="plan"
                component="div"
                className="text-danger mt-1"
                style={{ fontSize: "0.875rem" }}
              />
            </div>
          </Col>
        );

      case "investor":
        return (
          <Col sm={12} key="investor">
            <div>
              <label htmlFor="investor" className="font-label">
                Are you the sole Investor if you obtain the Kangaroo Education
                Foundation's Regional Office, or are there other investors
                involved?*
                <br />
              </label>
              <div className="d-flex align-items-center gap-4">
                <label className="d-flex align-items-center gap-2 font-label">
                  <Field
                    type="radio"
                    name="investor"
                    value="sole"
                    style={{ transform: "scale(1.4)", cursor: "pointer" }}
                  />
                  Yes I am the Sole Investor
                </label>
                <label className="d-flex align-items-center gap-2 font-label">
                  <Field
                    type="radio"
                    name="investor"
                    value="multiple"
                    style={{ transform: "scale(1.4)", cursor: "pointer" }}
                  />
                  No there are other Investors as well
                </label>
              </div>
              <ErrorMessage
                name="investor"
                component="div"
                className="text-danger mt-1"
                style={{ fontSize: "0.875rem" }}
              />
            </div>
          </Col>
        );

      case "address":
        return (
          <Col key="address">
            <div>
              <label htmlFor="address" className="font-label">
                Address*
              </label>
              <Field
                type="text"
                name="address"
                className={`form-control form-box py-3 ${touched.address && errors.address ? "is-invalid" : ""
                  }`}
                id="address"
              />
              <ErrorMessage
                name="address"
                component="div"
                className="text-danger mt-1"
                style={{ fontSize: "0.875rem" }}
              />
            </div>
          </Col>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Formik
        initialValues={createInitialValues()}
        validationSchema={createValidationSchema()}
        onSubmit={handleSubmit}
        validateOnChange={true}
        validateOnBlur={true}
      >
        {(formik) => (
          <div>
            {fields.map((field, index) => (
              <div key={index} className="mb-2">
                {renderField(field, formik)}
              </div>
            ))}

            <div
              className="d-flex justify-content-end"
              style={{
                marginTop: "5.5rem",
                marginBottom: "12.5rem",
                width: "100%",
              }}
              onClick={() => {
                formik.handleSubmit();
              }}
              disabled={formik.isSubmitting}
            >
              <Smallbutton
                className="ms-auto"
                text="SUBMIT"
                style={{ width: "clamp(150px, 20vw, 250px)" }}
              />
            </div>
          </div>
        )}
      </Formik>
      {props.closeFormat === "pink" && (
        <FormClosepink
          modal={thankYouModal}
          toggle={toggleThankYou}
          description={props.closingdesc}
        />
      )}
      {props.closeFormat === "normal" && (
        <FormClose
          modal={thankYouModal}
          toggle={toggleThankYou}
          heading={props.closingHeading}
          description={props.closingdesc}
        />
      )}
      {props.closeFormat === "gold" && (
        <FormGoldBg
          modal={thankYouModal}
          toggle={toggleThankYou}
          heading={props.closingHeading}
        />
      )}{" "}
      {props.gameClose && (
        <Modal
          isOpen={thankYouModal}
          toggle={toggleThankYou}
          size="lg"
          backdrop="static"
          closeOnOutsideClick={false}
          closeOnBlur={false}
          contentClassName="game-end"
        >
          <ModalHeader
            toggle={toggleThankYou}
            style={{ borderBottom: "0px" }}
          // close={closeBtn}
          ></ModalHeader>

          <ModalBody className="p-0">
            <div className="d-flex justify-content-center align-items-center p-0 ">
              <div style={{ width: "45%" }}>
                <img
                  src={gameimg5}
                  fluid
                  className="w-100 h-100 p-0 m-0"
                  alt=""
                />
              </div>
              <div style={{ width: "55%" }}>
                <h1 className="font-level-4 lh-1" style={{ color: "white" }}>
                  THANK YOU, <br /> YOU'RE ALL SET!
                </h1>
                <p className="game-desc-font my-3" style={{ color: "white" }}>
                  We’ve received your details. Our team will reach out shortly
                  to guide you with the next steps in your study journey.
                </p>
                <div
                  className="mt-5"
                  onClick={() => {
                    toggleThankYou();
                    props.closeAllModals();
                  }}
                >
                  <Smallbutton
                    text="CLOSE"
                    fill="transparent"
                    strokeColor="#fff"
                    textColor="#fff"
                  />
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default Fullform;
